"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startDefaultContext = startDefaultContext;
const browser_core_1 = require("@datadog/browser-core");
function startDefaultContext(hooks, configuration, sdkName) {
    hooks.register(0 /* HookNames.Assemble */, ({ eventType }) => {
        const source = configuration.source;
        return {
            type: eventType,
            _dd: {
                format_version: 2,
                drift: (0, browser_core_1.currentDrift)(),
                configuration: {
                    session_sample_rate: (0, browser_core_1.round)(configuration.sessionSampleRate, 3),
                    session_replay_sample_rate: (0, browser_core_1.round)(configuration.sessionReplaySampleRate, 3),
                    profiling_sample_rate: (0, browser_core_1.round)(configuration.profilingSampleRate, 3),
                },
                browser_sdk_version: (0, browser_core_1.canUseEventBridge)() ? "6.22.0" : undefined,
                sdk_name: sdkName,
            },
            application: {
                id: configuration.applicationId,
            },
            date: (0, browser_core_1.timeStampNow)(),
            source,
        };
    });
    hooks.register(1 /* HookNames.AssembleTelemetry */, () => ({
        application: { id: configuration.applicationId },
    }));
}
//# sourceMappingURL=defaultContext.js.map